import { useMemo } from 'react';

export const useImageStyleName = ({ customStyles, generalStyles, selectedImageStyleId }) => {
  return useMemo(() => {
    const generalStyle = generalStyles.find((style) => style.id === selectedImageStyleId);
    if (generalStyle) {
      return generalStyle.name;
    }

    const customStyle = customStyles.find((style) => style.id === selectedImageStyleId);
    if (customStyle) {
      return customStyle.name;
    }

    return '';
  }, [customStyles, generalStyles, selectedImageStyleId]);
};
